import React from "react";
import { useForm } from "react-final-form";
import { useHistory } from "react-router";
import { Col, Row } from "reactstrap";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import Icon, { IconName } from "src/components/Icon/Icon";
import * as S from "src/constants/StringConstants";
import { GMEGSIEntity, schoolToOption } from "../GMEDetails/GMEGSIEntity";

interface GMEDetailsProps {
  selectedGroups: GMEGSIEntity[];
  availableGroups: GMEGSIEntity[];
  applicationId: string;
}

const GSIDetails = ({ selectedGroups, availableGroups, applicationId }: GMEDetailsProps) => {
  const history = useHistory();
  const form = useForm();
  const value = form.getState().values.group;

  const handleAddGSIGroupClick = () => {
    history.push(`/applications/${applicationId}/add-gme-gsi?type=gsi`);
  };

  const activeCurrent = selectedGroups.find(school => school.gid === value);
  const currValue = availableGroups.find(school => school.gid === value);

  if (!activeCurrent && currValue) {
    selectedGroups.push(currValue);
  }

  return (
    <Col sm="6">
      <Row>
        <Col sm="3" className="app-form-header">
          <h4 className="form-title">{S.APP_GSI_DETAILS_TITLE}</h4>
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <TypeaheadField
            name="group"
            label={S.APP_GSI_DETAILS_FIELD_GROUP}
            options={selectedGroups.map(schoolToOption)}
          />
        </Col>

        <Col sm="5" className="d-flex align-items-center">
          <button className="app-gme-gsi__add-button" onClick={handleAddGSIGroupClick}>
            <Icon name={IconName.PlusBlue} size="24px" />
            <span>{S.APP_GSI_DETAILS_BUTTON_ADD_GSI_GROUP}</span>
          </button>
        </Col>
      </Row>
    </Col>
  );
};

export default GSIDetails;
